import React, { useState } from "react"
import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent"
import LoanDetailsModal from "./LoanDetailsModal/LoanDetailsModal"

const ManageLoans = () => {

  const [isModalOpen, setIsModalOpen] = useState(false)

  const manageLoans = [
    { id: "#1234567", loanAmount: "$10,000", loanType: "$50,000", repaymentOption: "Automatic Deduction", nextPaymentDue: '-', status: 'Pending' },
    { id: "#1234567", loanAmount: "$10,000", loanType: "$50,000", repaymentOption: "Automatic Deduction", nextPaymentDue: '20/07/2024', status: 'Approved' },
    { id: "#1234567", loanAmount: "$10,000", loanType: "$50,000", repaymentOption: "Automatic Deduction", nextPaymentDue: '-', status: 'Pending' },
    { id: "#1234567", loanAmount: "$10,000", loanType: "$50,000", repaymentOption: "Automatic Deduction", nextPaymentDue: '20/07/2024', status: 'Disbursed' },
  ]

  const columns = [
    { name: "Loan ID", selector: (row) => row.id },
    { name: "Loan Amount", selector: (row) => row.loanAmount },
    { name: "Loan Type", selector: (row) => row.loanType },
    { name: "Repayment Option", selector: (row) => row.repaymentOption },
    { name: "Next Payment Due", selector: (row) => row.nextPaymentDue },
    { name: "Status", selector: (row) => row.status },
    { name: "Action", cell: () => <span className="cursor-pointer" onClick={() => setIsModalOpen(true)}>View details</span> },
  ]

  return (
    <div>

      <div className="fw-semibold fs-5 my-3">Manage Loans</div>
      <div className="bg-white p-3">
        <DatatableComponent data={manageLoans} columns={columns} type={"yellow"} />
      </div>

      <LoanDetailsModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
    </div>
  )
}

export default ManageLoans
